/**
 * The API sits behind API Gateway, which caps the whole Lambda request at 6 MB, and multipart
 * bodies arrive base64-encoded (+33%). Anything bigger never reaches Laravel and comes back
 * as a bodyless 413. Keep this in sync with Image::MAX_UPLOAD_KILOBYTES and the file `max:` rules.
 */
export const MAX_UPLOAD_BYTES = 4 * 1024 * 1024;

export const MAX_UPLOAD_LABEL = '4 MB';
